<template >
	<div>
		<button
			class="btn btn-outline-light align-right p-0 px-lg-1 mr-md-2 btn-usuario"
			:id="id"
			type="button"
		>
			<div class="d-flex align-items-center">
				<i class="d-none d-lg-inline icon-grupo-4353 user-icon"></i>
				<span class="d-none d-xl-inline user-text">{{usuarioGlobal().name}}</span>
				<i class="icon-grupo-4357 three-point-menu-icon"></i>
			</div>
		</button>
		<b-popover placement="bottom" :target="id" triggers="hover" >
			<ul class="list-group list-unstyled">
				<li class="list-group-item m-0 p-1 border-0">
					<router-link class="text-decoration-none" to="/clientes/configuracion">Configuración</router-link>
				</li>
				<li @click="logOut" class="list-group-item m-0 p-1 border-0">
					<a class="text-decoration-none" href="#">Cerrar sesión</a>
				</li>
			</ul>
		</b-popover>
	</div>
</template>

<script>
	export default {
		props:{
			id: {
				type: String,
				required: true,
				default: 'pop-menu'
			}
		},
		methods: {
			logOut() {
				//window.localStorage.removeItem("user")
				//window.localStorage.removeItem("token")
				//window.localStorage.removeItem("expiresIn")
				//window.localStorage.removeItem("refreshToken")
				window.localStorage.removeItem("tokenDifarmer")


				this.$router.push({ path: "/" })
			}
		}
	}
</script>

<style>
	.btn-usuario {
		overflow: hidden;
	}

	.user-icon {
		font-size: 19px;
	}

	.three-point-menu-icon {
		font-size: 19px;
		font-weight: lighter;
	}

	.user-text {
		font-size: 15px;
		white-space: nowrap;
	}

	.popover-user-option {
		font-size: 14px;
		text-align: left;
		border: none;
		min-width: 150px;
		border-radius: 3px;
	}

	.popover-user-option .popover-body {
		padding: 0.5rem;
	}

	.popover-user-option.bs-popover-auto[x-placement^="bottom"] > .arrow::after,
	.popover-user-option.bs-popover-bottom > .arrow::after {
		border-bottom-color: white;
	}

	.popover-user-option ul {
		padding: 0rem;
		/*margin-bottom: 0.1rem;*/
	}

	.popover-user-option ul li {
		list-style: none !important;
		/*margin: 0.2rem 0rem;*/
	}
	.popover-user-option ul li a {
		text-decoration: none;
		color: var(--color-font-blue);
	}
</style>